import { connect } from 'react-redux';
import * as metaSelectors from 'redux-modules/meta/selectors.js';
import ProjectOverview from './ProjectOverview';

function mapStateToProps(state) {
  return {
    indexedMeta: metaSelectors.selectIndexedMeta(state)
  };
}

export default connect(mapStateToProps, null)(ProjectOverview);
